import classNames from 'classnames';
import { FC } from 'react';
import seoBlockActionHolderCss from './assets/seo-block-action-holder.module.scss';
import { SeoBlockAction } from './SeoBlockAction';
import { useSeoBlockContext } from './hooks';

const SeoBlockActionHolder: FC = () => {
  const { isVisible } = useSeoBlockContext();

  return (
    <div
      className={classNames(
        seoBlockActionHolderCss.seoBlockActionHolder,
        { [seoBlockActionHolderCss.seoBlockActionHolder_visible]: isVisible },
      )}
    >
      <SeoBlockAction />
    </div>
  );
};

export { SeoBlockActionHolder };
